import { Spin } from "antd";
import { Loader } from "./styled";

const SpinLoader = () => (
  <Loader>
    <Spin />
  </Loader>
);

export default SpinLoader;
